export default (params) => ({
  trigger: {
    name: 'insurance_selector.select_no_insurance_option',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'add_to_cart_overlay',
          'add_to_cart_page',
          'shopping_cart',
          'employee_atc_page',
          'employee_ato_page',
          'business_atc_page',
        ],
      },
    },
    event: {
      name: 'remove_item',
      params: {
        list: null,
        item_id: null,
      },
    },
    nonInt: true,
  },
});
